import { Component } from '@angular/core';
import { RoomsFacade } from '@library/store/rooms/rooms.facade';
import { RoomsAssets } from '@library/utils/constants/rooms';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { ControlPageStore, GraphType } from '@pages/control-page/control-page-store.service';
import { combineLatest, map, share, startWith, withLatestFrom } from 'rxjs';

const LABELS: Record<GraphType, string> = {
  [GraphType.TEMPERATURE]:        'common-app.__TEMPERATURE',
  [GraphType.HUMIDITY]:           'common-app.__HUMIDITY',
  [GraphType.RAIN]:               'common-app.__RAIN',
  [GraphType.WIND]:               'common-app.__WIND',
  [GraphType.PRESSURE]:           'common-app.__PRESSURE',
  [GraphType.NOISE]:              'common-app.__NOISE',
  [GraphType.CO2]:                'common-app.__CO2',
  [GraphType.THERM]:              'common-app.__TEMPERATURE',
  [GraphType.ELEC]:               'legrand-app.__LEG_COM_CONSO',
  [GraphType.ELEC_PEAK_OFFPEAK]:  'legrand-app.__LEG_COM_CONSO',
  [GraphType.WATER]:              'legrand-app.__LEG_WATER',
  [GraphType.GAS]:                'legrand-app.__GAS',
};

const ICONS: Partial<Record<GraphType, string>> = {
  [GraphType.ELEC]:               'flash',
  [GraphType.ELEC_PEAK_OFFPEAK]:  'flash',
  [GraphType.WATER]:              'water',
  [GraphType.GAS]:                'gas',
};

@Component({
  selector: 'app-control-page-graph-header',
  templateUrl: './control-page-graph-header.component.html',
  styleUrls: ['./control-page-graph-header.component.scss']
})
export class ControlPageGraphHeaderComponent {

  private room$ = this.controlPageStore.card$.pipe(
    isDefined(),
    withLatestFrom(this.roomsFacade.rooms$),
    map(([card, rooms]) => rooms.find(r => r.id === (card.module?.room_id ?? card.room?.id))),
    share(),
  );

  private roomName$ = this.room$.pipe(
    map(room =>  room ? room.name : false),
    startWith(false),
  );

  private roomType$ = this.room$.pipe(
    map(room => room ? room.type : null),
  );

  vm$ = combineLatest({
    card: this.controlPageStore.card$,
    roomName: this.roomName$,
    roomType: this.roomType$,
  });

  LABELS = LABELS;
  ICONS = ICONS;
  RoomsAssets = RoomsAssets;

  constructor(
    private controlPageStore: ControlPageStore,
    private roomsFacade: RoomsFacade,
  ) { }

}
